import { ReactNode } from 'react';

import { clsx } from '@freelancelabs/utils';

import { Ellipsis } from '../ellipsis';

export type BadgeSize = 'small' | 'medium';
export type BadgeCategory = 'default' | 'danger' | 'warning' | 'success' | 'info' | 'brand';

export interface BadgeProps {
    /** Determines which icon to render based on its name */
    children: string;
    /** The size of the badge */
    size?: BadgeSize;
    /** The color of the badge */
    category?: BadgeCategory;
    /**
     * Une icone posee AVANT le texte, dans la pastille.
     *
     * Elle existe pour les pastilles qui nomment un RANG et non un statut : deux rangs sur
     * une meme rangee ne peuvent pas se distinguer par la teinte seule, et une forme le dit
     * a qui ne la percoit pas. Le texte garde son ellipse, l'icone n'y entre pas.
     */
    icon?: ReactNode;
    /** Le texte complet, quand `children` est deja une valeur lisible mais pas explicite. */
    title?: string;
}

const Badge = ({ children, size = 'medium', category = 'default', icon, title }: BadgeProps) => {
    /* `icon ? … : undefined` et non `icon && …` : `clsx` n'accepte pas un `ReactNode`
       faux, et une icone est un noeud et non un booleen. */
    const badgeClassName = clsx('badge', `badge-${category}`, `badge-${size}`, icon ? 'badge-with-icon' : undefined);
    return (
        <span className={badgeClassName} title={title}>
            {icon}
            <Ellipsis text={children} displayTooltip>
                {children}
            </Ellipsis>
        </span>
    );
};

export default Badge;
